module.exports = "<% var curr = me.model.get(me.name) %>\n<textarea class=\"form-control cooper-main-input\" name=\"<%=me.name%>\"><%=curr%></textarea>\n"